import { Component, output, signal } from '@angular/core';
import { TimePickerValue } from '@app/shared/types/models/shared/time-picker-value';
import { UiChoiceGroupComponent } from '@app/shared/ui/choice-group/ui-choice-group.component';
import { ProffeoUiChoiceCompareWith, ProffeoUiChoiceOption } from '@app/shared/ui/types/choice-group.types';

@Component({
  selector: 'proffeo-time-buttons',
  templateUrl: './time-buttons.component.html',
  imports: [UiChoiceGroupComponent],
  host: {
    class: 'block w-full'
  }
})
export class TimeButtonsComponent {
  protected readonly selectedValue = signal<TimePickerValue | null>(null);
  protected readonly options: readonly ProffeoUiChoiceOption<TimePickerValue>[] = [
    { value: { hours: 0, minutes: 15 }, label: '15m' },
    { value: { hours: 0, minutes: 30 }, label: '30m' },
    { value: { hours: 0, minutes: 45 }, label: '45m' },
    { value: { hours: 1, minutes: 0 }, label: '1h' },
    { value: { hours: 2, minutes: 0 }, label: '2h' },
    { value: { hours: 3, minutes: 0 }, label: '3h' },
    { value: { hours: 4, minutes: 0 }, label: '4h' },
    { value: { hours: 5, minutes: 0 }, label: '5h' },
    { value: { hours: 7, minutes: 30 }, label: '7h 30m' },
    { value: { hours: 10, minutes: 0 }, label: '10h' }
  ];

  public readonly timeSelected = output<TimePickerValue>();

  protected readonly compareTimeValues: ProffeoUiChoiceCompareWith<TimePickerValue> = (first, second): boolean =>
    !!first && !!second && first.hours === second.hours && first.minutes === second.minutes;

  protected onValueChange(value: TimePickerValue | null): void {
    this.selectedValue.set(value);
    if (value) {
      this.timeSelected.emit(value);
    }
  }
}
